import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface MenuItem {
  id: string;
  page_key: string;
  page_title: string;
  page_title_ar: string | null;
  menu_type: string;
  parent_id: string | null;
  display_order: number;
  menu_visible: boolean;
  is_active: boolean;
  cta_link: string | null;
  children?: MenuItem[];
}

export const useMenuItems = () => {
  const [menuItems, setMenuItems] = useState<MenuItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMenuItems = async () => {
      const { data } = await supabase
        .from("page_content")
        .select("id, page_key, page_title, page_title_ar, menu_type, parent_id, display_order, menu_visible, is_active, cta_link")
        .eq("menu_visible", true)
        .eq("is_active", true)
        .order("display_order");

      if (data) {
        // Build hierarchy
        const sections = (data as MenuItem[]).filter(i => i.menu_type === "section");
        const subsections = (data as MenuItem[]).filter(i => i.menu_type === "subsection");

        const tree = sections.map(section => ({
          ...section,
          children: subsections
            .filter(sub => sub.parent_id === section.id)
            .sort((a, b) => a.display_order - b.display_order),
        }));

        setMenuItems(tree);
      }
      setLoading(false);
    };

    fetchMenuItems();
  }, []);

  return { menuItems, loading };
};
